import 'maplibre-gl/dist/maplibre-gl.css';
import './styles.css';
import { createRoot } from 'react-dom/client';
import { CookieBanner } from './components/CookieBanner';
import { DebugPanel, debugRequested } from './components/DebugPanel';
import { Account } from './pages/Account';
import { AddPlace } from './pages/AddPlace';
import { Admin } from './pages/Admin';
import { Advertise } from './pages/Advertise';
import { Directory, STATE_CODES } from './pages/Directory';
import { Home } from './pages/Home';
import { Listing } from './pages/Listing';
import { Manage } from './pages/Manage';
import { PlaceListing } from './pages/PlaceListing';
import { Static } from './pages/Static';
import { Submit } from './pages/Submit';
import { SubmitThanks } from './pages/SubmitThanks';
import { VerifySignIn } from './pages/VerifySignIn';
import { installLinkInterceptor, usePath } from './router';

function Router() {
  const path = usePath();
  let m: RegExpMatchArray | null;
  if (path === '/' || path === '/map' || path === '/map/') return <Home />;
  if ((m = path.match(/^\/e\/([A-Z2-9]{8})\/?$/))) return <Listing key={m[1]} publicId={m[1]!} />;
  if ((m = path.match(/^\/place\/([A-Z2-9]{8})\/?$/)))
    return <PlaceListing key={m[1]} publicId={m[1]!} />;
  if (path === '/submit/thanks' || path === '/submit/thanks/') return <SubmitThanks />;
  if (path === '/submit' || path === '/submit/') return <Submit />;
  if (path === '/add-place' || path === '/add-place/') return <AddPlace />;
  if ((m = path.match(/^\/manage\/([A-Za-z0-9_-]+)\/?$/))) return <Manage token={m[1]!} />;
  if (path === '/admin' || path === '/admin/') return <Admin />;
  if (path === '/account' || path === '/account/') return <Account />;
  if ((m = path.match(/^\/sign-in\/([A-Za-z0-9_-]+)\/?$/)))
    return <VerifySignIn key={m[1]} token={m[1]!} />;
  if (path === '/advertise' || path === '/advertise/') return <Advertise />;

  // /va and /va/roanoke: the server's state and city directory pages (before the generic static
  // matcher, which would otherwise treat "va" as a page slug and report it missing).
  if ((m = path.match(/^\/([a-z]{2})(?:\/([a-z0-9-]+))?\/?$/)) && STATE_CODES.has(m[1]!))
    return <Directory key={path} path={path.replace(/\/$/, '')} />;
  if ((m = path.match(/^\/([a-z-]+)\/?$/))) return <Static key={m[1]} slug={m[1]!} />;
  return <Static slug="__not_found" />;
}

installLinkInterceptor();
createRoot(document.getElementById('root')!).render(
  <>
    <Router />
    <CookieBanner />
    {debugRequested() && <DebugPanel />}
  </>,
);
